<template>
  <div class="auth-container">
    <div class="auth-card">
        <div class="system-title">
    <h1>{{ systemConfig.website_name }}</h1>
    <p>探索虚拟现实的无限可能</p>
  </div>
      <div class="auth-header">
        <el-tabs v-model="activeTab" stretch @tab-click="handleTabClick">
          <el-tab-pane name="login" label="用户登录"></el-tab-pane>
          <el-tab-pane name="register" label="用户注册"></el-tab-pane>
        </el-tabs>
      </div>

      <el-form :model="form" :rules="rules" ref="authForm" class="auth-form">
        <el-form-item prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            @keyup.enter.native="submitForm"
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            @keyup.enter.native="submitForm"
          />
        </el-form-item>

        <el-button type="primary" @click="submitForm" class="submit-btn" >
          {{ activeTab === "login" ? "立即登录" : "立即注册" }}
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login, register, getPublicSystemConfig } from "@/api/index.js";
export default {
  data() {
    return {
      activeTab: "login",
      form: {
        name: "",
        password: "",
      },
      rules: {
        name: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
          { min: 3, max: 50, message: "用户名长度3-50位", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { min: 8, message: "密码长度至少8位", trigger: "blur" },
        ],
      },
      // 系统配置
      systemConfig: {
        website_logo: null,
        website_name: "2HVR游戏平台",
        customer_service_qr: null,
        chat_group_qr: null,
        third_party_config: {}
      }
    };
  },
  mounted() {
    this.loadSystemConfig();
  },
  methods: {
    handleTabClick() {
      this.form.name = "";
      this.form.password = "";
    },
    submitForm() {
      this.$refs.authForm.validate((valid) => {
        if (valid) {
          const fn = this.activeTab == "login" ? login : register;
          fn(this.form)
            .then((res) => {
              if (this.activeTab === "login") {
                localStorage.setItem("userInfo", JSON.stringify(res.data));
                localStorage.setItem("token", res.data.token); // 存储token到本地存储
                this.$router.push("/");
                this.$message.success("登录成功");
                this.form.name = "";
                this.form.password = "";
              } else {
                this.$message.success("注册成功");
                this.activeTab = "login";
                this.handleTabClick();
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        }
      });
    },

    // 加载系统配置
    async loadSystemConfig() {
      const cacheKey = 'system_config_cache';
      const cacheTimeKey = 'system_config_cache_time';
      const cacheExpireHours = 24; // 24小时过期
      
      try {
        // 检查缓存
        const cachedConfig = localStorage.getItem(cacheKey);
        const cacheTime = localStorage.getItem(cacheTimeKey);
        
        if (cachedConfig && cacheTime) {
          const cacheTimestamp = parseInt(cacheTime);
          const currentTime = Date.now();
          const timeDiff = currentTime - cacheTimestamp;
          const hoursDiff = timeDiff / (1000 * 60 * 60);
          
          // 如果缓存未过期（小于24小时），使用缓存数据
          if (hoursDiff < cacheExpireHours) {
            const parsedConfig = JSON.parse(cachedConfig);
            this.systemConfig = {
              website_logo: parsedConfig.website_logo || this.systemConfig.website_logo,
              website_name: parsedConfig.website_name || this.systemConfig.website_name,
              customer_service_qr: parsedConfig.customer_service_qr || this.systemConfig.customer_service_qr,
              chat_group_qr: parsedConfig.chat_group_qr || this.systemConfig.chat_group_qr,
              third_party_config: parsedConfig.third_party_config || this.systemConfig.third_party_config
            };
            console.log('使用缓存的系统配置');
            return;
          }
        }
        
        // 缓存不存在或已过期，请求接口
        const domain = location.host;
        const response = await getPublicSystemConfig({ domain });
        if (response.data) {
          // 更新系统配置，保留默认值作为后备
          this.systemConfig = {
            website_logo: response.data.website_logo || this.systemConfig.website_logo,
            website_name: response.data.website_name || this.systemConfig.website_name,
            customer_service_qr: response.data.customer_service_qr || this.systemConfig.customer_service_qr,
            chat_group_qr: response.data.chat_group_qr || this.systemConfig.chat_group_qr,
            third_party_config: response.data.third_party_config || this.systemConfig.third_party_config
          };
          
          // 缓存新数据和时间戳
          localStorage.setItem(cacheKey, JSON.stringify(response.data));
          localStorage.setItem(cacheTimeKey, Date.now().toString());
          console.log('已更新系统配置缓存');
        }
      } catch (error) {
        console.error('加载系统配置失败:', error);
        // 失败时尝试使用缓存数据
        const cachedConfig = localStorage.getItem(cacheKey);
        if (cachedConfig) {
          try {
            const parsedConfig = JSON.parse(cachedConfig);
            this.systemConfig = {
              website_logo: parsedConfig.website_logo || this.systemConfig.website_logo,
              website_name: parsedConfig.website_name || this.systemConfig.website_name,
              customer_service_qr: parsedConfig.customer_service_qr || this.systemConfig.customer_service_qr,
              chat_group_qr: parsedConfig.chat_group_qr || this.systemConfig.chat_group_qr,
              third_party_config: parsedConfig.third_party_config || this.systemConfig.third_party_config
            };
            console.log('接口请求失败，使用缓存的系统配置');
          } catch (parseError) {
            console.error('解析缓存配置失败:', parseError);
          }
        }
        // 失败时使用默认配置，不显示错误信息给用户
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/dark-theme.scss";

.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: $dark;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba($primary, 0.1) 0%, transparent 70%);
    animation: rotate 30s linear infinite;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.auth-card {
  @include glass-effect;
  padding: 48px;
  border-radius: $radius-2xl;
  box-shadow: $shadow-lg;
  width: 440px;
  border: $border-light;
  position: relative;
  z-index: 1;
  transition: $transition-normal;

  &:hover {
    box-shadow: $shadow-primary;
  }
}

.system-title {
  text-align: center;
  margin-bottom: 32px;
  
  h1 {
    @include gradient-text;
    font-size: 32px;
    margin-bottom: 8px;
    font-weight: 700;
  }
  
  p {
    color: $slate-400;
    font-size: 14px;
  }
}

.auth-header :deep(.el-tabs__item) {
  font-size: 18px;
  color: $slate-400;
  height: 60px;
  line-height: 60px;
  transition: $transition-normal;
  font-weight: 500;
}

.auth-header :deep(.el-tabs__item.is-active) {
  color: white;
  font-weight: 600;
}

.auth-header :deep(.el-tabs__active-bar) {
  background: $gradient-primary;
  height: 3px;
}

.auth-header :deep(.el-tabs__nav-wrap::after) {
  background-color: rgba(255, 255, 255, 0.1);
}

.auth-form {
  margin-top: 32px;

  :deep(.el-form-item__content) {
    line-height: normal;
  }

  :deep(.el-input__inner) {
    background: rgba(255, 255, 255, 0.05);
    border: $border-lighter;
    color: white;
    height: 48px;
    border-radius: $radius-md;
    font-size: 15px;
    transition: $transition-normal;

    &::placeholder {
      color: $slate-400;
    }

    &:focus {
      background: rgba(255, 255, 255, 0.08);
      border-color: $primary;
      box-shadow: 0 0 0 3px rgba($primary, 0.1);
    }
  }

  :deep(.el-input__prefix) {
    color: $slate-400;
  }

  :deep(.el-input__suffix) {
    color: $slate-400;
  }
}

.submit-btn {
  width: 100%;
  margin-top: 24px;
  letter-spacing: 2px;
  font-size: 16px;
  height: 48px;
  border-radius: $radius-xl;
  background: $gradient-primary;
  border: none;
  font-weight: 600;
  transition: $transition-normal;

  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: $shadow-primary;
  }

  &:active {
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .auth-card {
    width: 90%;
    padding: 32px 24px;
  }

  .auth-header :deep(.el-tabs__item) {
    font-size: 16px;
  }

  .system-title h1 {
    font-size: 28px;
  }
}

@media (max-width: 480px) {
  .auth-card {
    width: 100%;
    padding: 28px 20px;
  }

  .submit-btn {
    font-size: 14px;
  }

  .system-title h1 {
    font-size: 24px;
  }
}
</style>
